
import React, { useState } from 'react';
import './ScrollButton.css';

const ScrollButton = () => {

  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 0) {
      setVisible(true)
    }
    else if (scrolled <= 300) {
      setVisible(false)
    }
  };

  const scrollToTop = (e) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (

    <a href="null"
      id="scroll-top"
      className={visible ? "floating-icon active" : "floating-icon" }
      onClick={scrollToTop}>
      <i className="fa fa-chevron-up" aria-hidden="true"></i>
    </a >


    //<Button className="floating-icon">
    //  <div
    //    className="fa fa-chevron-circle-up"
    //    onClick={scrollToTop}
    //    style={{ display: visible ? 'inline' : 'inline' }} />
    //</Button>


  );
}

export default ScrollButton; 
